<template>
  <div class="d-flex h-100 flex-column">
    <nav class="navbar navbar-expand-lg navbar-dark bg-darkblue" :class="mainNavClass" ref="mainNav" id="jy-navbar-main">
      <a class="navbar-brand" href="javascript:;" @click="toggleSlide">
        <i class="fa fa-bars" :class="{'fa-rotate-90': !showSlideTitle}"></i>
        &nbsp;&nbsp;<span class="d-inline-block">{{ sitetitle }}</span>
      </a>
      <button class="navbar-toggler" type="button" @click="mainNavbar" data-target="#jy-navbarText" aria-controls="jy-navbarText" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-circle-down" :class="mainNavBtnClass"></i>
      </button>
      <div class="collapse navbar-collapse" :class="mainNavClass" id="jy-navbarText" ref="mainNav">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <router-link to="/" class="nav-link">主页</router-link>
          </li>
          <li v-if="hasPermiss('news.info.add')" class="nav-item active">
            <router-link to="/news-add" class="nav-link text-warning">添加内容</router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/news-list" class="nav-link">内容管理</router-link>
          </li>
          <li v-if="hasPermiss('news.info.edit')" class="nav-item active">
            <router-link to="/news-single" class="nav-link">单项内容</router-link>
          </li>
          <li class="nav-item active">
            <a href="/" target="dx_site" class="nav-link">网站首页</a>
          </li>
          <!-- <li class="nav-item">
            <a href="/" class="nav-link" target="_blank">网站</a>
          </li>
          <li v-if="hasPermiss('stu.info.query')" class="nav-item">
            <router-link to="/stu-list" class="nav-link">用户</router-link>
          </li>
          <li v-if="hasPermiss('point.info.query')" class="nav-item">
            <router-link to="/point-list" class="nav-link">积分</router-link>
          </li>
          <li v-if="hasPermiss('goods.info.query')" class="nav-item">
            <router-link to="/goods-info" class="nav-link">商城</router-link>
          </li>
          <li v-if="hasPermiss('stat.point.query')" class="nav-item">
            <router-link to="/stat-point" class="nav-link text-danger">排行榜</router-link>
          </li> -->
          <!--
          <li class="nav-item ml-5">
            <router-link class="nav-link text-danger font11" to="/group-list-all"><i class="fa fa-star fa-fw"></i>团计划(本公司)</router-link>
          </li>
          <li v-if="hasPermiss('platform.group.query')" class="nav-item">
            <router-link class="nav-link text-danger font11" to="/platform-group"><i class="fa fa-cloud fa-fw"></i>团计划(云平台)</router-link>
          </li>
          -->
        </ul>
        <span class="navbar-text">
          <el-popover
            ref="popover-user"
            placement="bottom"
            width="400"
            trigger="click">
            <el-form size="small" label-width="65px" class="view-form">
            <el-row type="flex" class="flex-wrap text-dark view-row" style="border:1px #eee solid;">
              <form-item label="账号" fill="2">
                <span>{{ userinfo.username }}</span>
              </form-item>
              <form-item label="密码" fill="2">
                <span><a href="javascript:;" class="text-danger" @click="doChangePassword">修改密码</a></span>
              </form-item>
              <form-item label="姓名" fill="2">
                <span>{{ userinfo.name }}</span>
              </form-item>
              <form-item label="性别" fill="2">
                <span>{{ userinfo.sex ? '男' : '女' }}</span>
              </form-item>
              <form-item label="手机" fill="2">
                <span>{{ userinfo.mobile }}</span>
              </form-item>
              <form-item label="角色" fill="4">
                <span><span v-for="(role) in userinfo.roleList" :key="role.id" class="d-inline-block mr-2">{{ role.name }}</span></span>
              </form-item>
              <!-- <form-item v-show="!userinfo.issuper" label="" fill="4" fill="2">
                <span slot="label">管理<br>区域</span>
                <span><span v-for="(area) in userinfo.areaList" :key="area.id" class="d-inline-block mr-2">{{ area.name }}</span></span>
              </form-item> -->
            </el-row>
            </el-form>
          </el-popover>
          <span><a href="javascript:;" v-popover:popover-user class="text-light"><i class="fa fa-smile-o fa-fw"></i>欢迎您，{{ userinfo.name }}</a></span>
          <span class="space">&nbsp;|&nbsp;</span>
          <span class="space">&nbsp;|&nbsp;</span>
          <span><a href="javascript:;" @click="logout" class="text-danger"><i class="fa fa-sign-out fa-fw"></i>注销</a></span>
        </span>
      </div>
    </nav>
    <div class="flex-grow-1 d-flex overflow-hidden">
      <div id="jy-sidenav-col" class="d-flex flex-column flex-shrink-0 h-100" ref="slidenav">
        <div id="jy-sidenav">
          <el-scrollbar
            tag="div" id="jy-sidenav-box"
            wrap-class="jy-sidenav-wrap"
            view-class="jy-sidenav-view"
            :class="{'overflow-visible': !showSlideTitle}"
            >
            <ul class="nav">
              <li v-for="r in routeData" :key="r.meta.r.k" @mouseenter="enterSlide(r, $event)" @mouseleave="leaveSlide(r, $event)"
                :class="{'isshow': r.isshow && showSlideTitle, 'open': (currentRoute === r.meta.r.k && showSlideTitle) || (showSlideTitle && routeData.length === 1), 'active': activeRoute === r.meta.r.k, 'sub-menu1': (!showSlideTitle && hoverRoute === r.meta.r.k)}">
                <a v-if="showSlideTitle" href="javascript:;" class="nav-link right-arrow" @click="clickSlideMenu(r, $event)">
                  <i class="fa fa-fw" :class="setSlideIcon(r.meta.r.icon, 'fa-caret-right')"></i>
                  <span v-show="showSlideTitle">&nbsp;{{ r.meta.r.v }}<b v-if="r.children"><i class="fa fa-angle-right"></i></b></span>
                </a>
                <el-tooltip v-else placement="left" effect="light" popperClass="submenu-tooltip">
                  <a href="javascript:;" class="nav-link right-arrow" @click="clickSlideMenu(r, $event)">
                    <i class="fa fa-fw" :class="setSlideIcon(r.meta.r.icon, 'fa-caret-right')"></i>
                    <span v-show="showSlideTitle">&nbsp;{{ r.meta.r.v }}<b><i class="fa fa-angle-right"></i></b></span>
                  </a>
                  <div slot="content">
                    <div v-if="r.children" class="card" style="width:11rem;">
                      <div class="card-header">{{ r.meta.r.v }}</div>
                      <div class="list-group list-group-flush">
                        <template v-for="(v, k) in r.children">
                          <a v-if="!v.meta.r.invalid && !v.meta.outslide" :key="k" href="javascript:;" @click="goToRotute(v, k)" class="list-group-item list-group-item-action" :class="{'router-link-active': current.path === v.path}">{{ v.meta.r.v }}</a>
                        </template>
                      </div>
                    </div>
                    <span v-else>{{ r.meta.r.v }}</span>
                  </div>
                </el-tooltip>
                <transition-group
                  v-if="r.children"
                  v-on:before-enter="navBeforeEnter"
                  v-on:enter="navEnter"
                  v-on:leave="navLeave"
                  v-bind:css="false"
                  mode="out-in"
                  tag="ul"
                  class="nav"
                >
                  <template v-for="(v, k) in r.children">
                    <li v-show="r.isshow && showSlideTitle" v-if="!v.meta.r.invalid && !v.meta.outslide" :key="k">
                      <router-link :to="{path:v.path.replace('/:id?', '')}" class="nav-link"><i class="fa fa-fw" :class="setSlideIcon(v.meta.r.icon, 'fa-angle-right')"></i> {{ v.meta.r.v }}</router-link>
                    </li>
                  </template>
                </transition-group>
              </li>
            </ul>
          </el-scrollbar>
        </div>
        <div class="mt-auto sidenav-collapse" @click="toggleSlide"><i class="fa" :class="[showSlideTitle ? 'fa-arrow-circle-left' : 'fa-arrow-circle-right']"></i></div>
      </div>
      <div class="d-flex h-100 flex-grow-1 flex-column overflow-hidden">
        <div id="jy-breadcrumb" class="d-flex">
          <ol class="breadcrumb main-breadcrumb mb-0 text-nowrap flex-nowrap">
            <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i> 主页</router-link></li>
            <li v-for="(p, i) in path" :key="p.path" class="breadcrumb-item" :class="{'active': (i + 1) == path.length}">
              <span v-if="(i + 1) < path.length && !p.path" key="breadcrumb-toggle" class="dropdown show" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
                <a href="javascript:;" class="dropdown-toggle">{{ p.meta.r.v }}</a>
                <transition name="fade">
                  <div class="dropdown-menu" v-show="showDropdown">
                    <template v-for="o in p.children">
                      <router-link v-if="!o.meta.r.invalid && !o.meta.outslide" :key="o.oath" :to="{path: o.path.replace('/:id?', '')}" class="dropdown-item">{{ o.meta.r && o.meta.r.v }}</router-link>
                    </template>
                  </div>
                </transition>
              </span>
              <router-link v-else-if="(i + 1) < path.length" :to="{path: p.meta.path || p.path, query: p.query}" key="breadcrumb-href">{{ p.meta.r && p.meta.r.v }}</router-link>
              <span v-else key="breadcrumb-text">{{ p.meta.r && (p.meta.r.v2 || p.meta.r.v) }}</span>
            </li>
          </ol>
          <div class="position-relative d-none d-md-flex align-items-center ml-auto flex-grow-1 noselect" style="margin-right:1rem; overflow:hidden; transition:all .2s" @mousewheel="wheelNav" @touchstart="moveNav" @mousedown="moveNav" ref="tagNav">
            <div class="d-flex">
              <el-tag v-for="(item, index) in tagRouteList"
                :key="item.path"
                class="ml-2 text-nowrap el-tag-route"
                :type="((current.name || current.path) != (item.name || item.path)) || !currentRoute || current.path === '/' ? 'info' : 'primary'"
                @click.stop="goTag(item, index)"
                @close="removeTag(item, index)" :closable="true">
                {{ item.meta.r && (item.meta.r.tagv || item.meta.r.v) }}
              </el-tag>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 overflow-hidden">
          <transition name="fade" mode="out-in">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in">
            <Home v-if="!firstLogin && current.path === '/'"> THIS IS HOME!</Home>
          </transition>
          <transition name="fade" mode="out-in">
            <router-view name="helpview"> THIS IS Help!</router-view>
          </transition>
        </div>
      </div>
      <!-- login box -->
      <JyLogin @login="loginOK" ref="loginDialog" />
      <!-- change password -->
      <JyUserPassword ref="passwordDialog" />
      <!-- login page - for first login -->
      <div v-if="firstLogin">
        <router-view name="login"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import * as types from 'jystore/mutation-types';
import { allRoute } from 'jyrouter/router-admin';
import Velocity from 'velocity-animate/velocity.min';
import tools from 'jyutils/tools';
import JyLogin from '@/admin/login.vue';
import JyUserPassword from '@/admin/user-password.vue';
import Home from '@/admin/home.vue';

let tabs = {};

export default {
  name: 'app',
  components: {
    JyLogin, JyUserPassword, Home
  },
  mixins: [tools],
  data () {
    return {
      path: [],
      current: 'home',
      tabs: tabs,
      routeData: [],
      isCollapse: true,
      showSlideTitle: true,
      collapseSlide: false,
      currentRoute: '',
      activeRoute: '',
      hoverRoute: '',
      slideTop: 0,
      mainNavClass: '',
      showDropdown: false,
      feecheck: {
        count: 0
      },
      payoutcheck: {
        count: 0
      },
      companycheck: {
        count: 0
      },
      // websocket: null,
      msg: {
        isok: false,
        count: 0,
        sendid: ''
      },
      rules: {
        username: [
          {required:true, message:'请填写登录账号！'}
        ],
        password: [{required:true, message:'请输入登录密码！'}]
      },
      tagRoute: {},
      tagRouteList: [],
      loginLoading: null,
    }
  },
  computed: {
    ...mapState(['firstLogin']),
    ...mapGetters({
      settingvue: 'settingvue',
      token: 'token',
      routers: 'routers',
    }),
    mainNavBtnClass() {
      return {
        show: this.mainNavClass
      }
    }
  },
  watch: {
    firstLogin(val) {
      if (!val) {
        this.$refs.loginDialog.show(false);
      } else {
        //console.log('...login...watch')
        // this.routeData = routeData.concat();
        this.doLogin();
      }
    },
    'userinfo.permissions'() {
      this.addRoute();
    },
    '$route'(to) {
      // console.log(to)
      if (to.path != '/' && to.path.indexOf(':') == -1 && !to.meta.outslide && (to.meta && to.meta.r)) {
        let router = {path: to.path, name: to.name, params: to.params, query: to.query, v: to.meta.r.v, count: 0};
        if (this.routers[to.path]) {
          router.count = this.routers[to.path].count + 1;
        }
        this.$store.commit('addRouters', {router: Object.assign({}, router)});
      }
    },
    routeData: {
      handler() {
      },
      deep: true
    },
  },
  created () {
    // 检查登录状态及token
    // this.$store.commit(types.JY_LOGIN_CHECK);
    // 取得token
    if (!this.$store.state.token) {
      this.getToken(() => {
        // console.log('err...')
      })
    }

    // axios 请求拦截
    this.$axios.interceptors.request.use((config) => {
      // 检查登录状态及token
      // this.$store.commit(types.JY_LOGIN_CHECK);
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    // axios 响应拦截
    this.$axios.interceptors.response.use((response) => {
      let json = response.data;
      if (json && json[types.KEY_STATUS] && json[types.KEY_STATUS] === types.CODE_TIMEOUT) {
        //this.doLogin();
        this.$store.dispatch(types.JY_LOGOUT);
      }
      return response;
    }, (error) => {
      return Promise.reject(error);
    });

    // Vue.http.interceptors.push((request, next) => {
    //   // 检查登录状态及token
    //   this.$store.commit(types.JY_LOGIN_CHECK);
    //   // 发送token
    //   request.headers.set('token', this.$store.state.token || 'token');
    //   // continue to next interceptor
    //   next((response) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
    //     // console.log('...this is vue http interceotors...');
    //     // console.log(request)
    //     let json = response.body;
    //     if (json && json[types.KEY_STATUS] && json[types.KEY_STATUS] === types.CODE_TIMEOUT) {
    //       //this.logout(true);
    //       this.doLogin();
    //     }
    //     return response;
    //   });
    // });

    let router = this.$router;
    if (this.firstLogin) {
      //router.push('/login');
    } else {
      if (router) {
        // 导航钩子 - before - 验证登录
        router.beforeEach((to, from, next) => {
          // 查询路由元信息，如果需要登录则跳转到登录页面
          if (to.matched.some(record => record.meta.noAuth)) {
            next()
          } else {
            if (this.$store.state.logged) {
              next()
            } else {
              next(false);
              this.loginVisible = true;
            }
          }
        });
      }
    }
  },
  mounted () {
    // if (this.firstLogin) {
      //console.log('/login...')
    //   this.doLogin();
    // }
    // title
    document.title = this.sitetitle +' - 管理';
    // 加载状态
    this.loginLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    // 检查登录状态及token
    this.$store.dispatch(types.JY_LOGIN_CHECK, (flag) => {
      // console.log(flag)
      if (!flag) {
        this.doLogin();
      }
      this.loginLoading.close();
    });

    this.$nextTick(() => {
      this.handleResize();
      //
      if (!this.currentRoute) {
        //this.activeRoute = (this.routeData[0] && this.routeData[0].meta) && this.routeData[0].meta.r.k;
        this.currentRoute = (this.routeData[0] && this.routeData[0].meta) && this.routeData[0].meta.r.k;
      }
    });

    let router = this.$router;
    // add router
    if (router) {
      //console.log('...........................')
      // console.log(router)
      //console.log('...........................')
      // 导航钩子
      router.afterEach(route => {
        // console.log('........after...go........'+ route.path);
        this.goto(route);
      });
    }

    this.current = router.currentRoute;
    // console.log(this.current.path)
    if (this.current.path && this.current.path.indexOf('/c-') === 0) {
      // go home
      // router.push(routeHome)
    } else {
      this.setPath();
      this.currentRoute = '';
      if (this.current.meta.parent) {
        this.currentRoute = this.current.meta.parent.meta.r.k;
      }
    }

    // window resize
    let resizeId1, resizeId2;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId1);
      resizeId1 = setTimeout(this.initUI, 500);
    });
    window.addEventListener('resize', () => {
      clearTimeout(resizeId2);
      resizeId2 = setTimeout(this.handleResize, 500);
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.initUI);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
      checkLogin: types.JY_LOGIN_CHECK,
      getToken: types.JY_TOKEN_GET,
      logout: types.JY_LOGOUT
    }),
    mainNavbar() {
      this.mainNavClass = this.mainNavClass ? '' : 'show';
    },
    showMessage() {
      this.$refs.message.show(true);
    },
    showFeeCheck() {
      this.$refs.feecheck.show(true);
    },
    showPayoutCheck() {
      this.$refs.payoutcheck.show(true);
    },
    showCompanyCheck() {
      this.$router.push('/sys-company-check');
    },
    // submenu - goto
    goToRotute(v) {
      this.$router.push({path:v.path, name:v.name, params:v.params, meta:v.meta});
    },
    goto(route) {
      if (route) {
        this.current = route;
        this.activeRoute = '';
        // console.log(route)
        if (route.path !== '/') {
          this.currentRoute = '';
        }
        if (this.current.meta && this.current.meta.parent) {
          this.currentRoute = this.current.meta.parent.meta.r.k;
          this.activeRoute = this.currentRoute;
        } else if (this.current.meta && this.current.meta.r && this.current.path) {
          this.currentRoute = this.current.meta.r.k;
          this.$router.push(route);
        }
        this.path = [];
        this.setPath();

        let key = route.name || route.path;
        if (key) {
          if (!this.tagRoute[key]) {
            this.tagRoute[key] = route;
          }

          this.filterTagRoute();

          // 切换tag
          this.$nextTick(() => {
            const _nav = this.$refs.tagNav;
            const _tag = _nav.querySelector('.el-tag--primary');
            const _left = _tag ? _tag.offsetLeft : 0;
            const w = _nav.scrollLeft + _nav.clientWidth;
            if (_tag) {
              if (_left < _nav.scrollLeft || _left > w) {
                _nav.scrollLeft = _tag.offsetLeft;
              }
              if ((_left + _tag.scrollWidth > w)) {
                _nav.scrollLeft += _tag.scrollWidth;
              }
            }
          });
        }
      }
    },
    setPath(target) {
      if (!target) {
        target = this.current;
      }
      if (target && target.path != '/') {
        this.path.unshift(target);
        if (target.meta && target.meta.parent2) {
          this.setPath(target.meta.parent2);
        } else {
          if (target.meta.parent)
            this.setPath(target.meta.parent);
        }
      }
    },
    filterTagRoute() {
      let list = [];
      Object.keys(this.tagRoute).forEach((key) => {
        if (this.tagRoute[key].meta && this.tagRoute[key].meta.r) {
          list.push(this.tagRoute[key]);
        }
      });
      this.tagRouteList = list;
    },
    goTag(route) {
      /*if (this.currentRoute && index === this.tagRouteList.length - 1 && this.current.path !== '/') {
        return;
      }*/
      let current = this.$route, currentname = current.name || '';
      if (route == current || (route.name == currentname || route.path == current.path)) {
        return;
      }
      this.$router.push({path:route.path, name:route.name, params:route.params, query:route.query, meta:route.meta});
    },
    removeTag(route, index) {
      const key = route.name || route.path;
      delete this.tagRoute[key];
      this.filterTagRoute();
      if (key == (this.current.name || this.current.path)) {
        if (this.tagRouteList.length && this.tagRouteList.length > index - 1) {
          let _index = index > 0 ? index - 1 : index
          this.goTag(this.tagRouteList[_index]);
        } else {
          this.$router.push({path: '/'});
        }
      }
    },
    navBeforeEnter(el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    navEnter(el, done) {
      var delay = el.dataset.index * 150;
      setTimeout(function () {
        Velocity(
          el,
          {opacity: 1, height:'2.5rem'},
          {complete: done}
        )
      }, delay)
    },
    navLeave(el, done) {
      var delay = el.dataset.index * 150;
      setTimeout(function () {
        Velocity(
          el,
          {opacity: 0, height:0},
          {complete: done}
        )
      }, delay)
    },
    toggleSlide() {
      let $this = this, width = this.showSlideTitle ? '2.3rem' : '14rem', delay = 300;
      let _showSlideTitle = false;
      if (this.showSlideTitle) {
        this.showSlideTitle = false;
      } else {
        _showSlideTitle = true;
        delay = 0;
      }
      setTimeout(function () {
        Velocity(
          $this.$refs.slidenav,
          {width: width},
          {
            begin: () => {
              // Velocity(
              //   $this.$refs.tabs,
              //   {'margin-left': width}
              // );
              if (_showSlideTitle) {
                $this.broadcast('JyPagebody', 'jy.slide.show');
                $this.broadcast('JyPagefooter', 'jy.slide.show');
              } else {
                $this.broadcast('JyPagebody', 'jy.slide.hide');
                $this.broadcast('JyPagefooter', 'jy.slide.hide');
              }
            },
            complete: () => {
              _showSlideTitle && ($this.showSlideTitle = true);
            }
          }
        );
      }, delay);
    },
    setSlideIcon(icon, defaultIcon) {
      return icon ? ('fa-'+ icon) : defaultIcon;
    },
    clickSlideMenu(r) {
      this.currentRoute = r.meta.r.k;
      if (r.path) {
        this.goto(r);
      }
      this.$set(r, 'isshow', r.isshow ? false : true);
    },
    enterSlide(r) {
      this.hoverRoute = r.meta.r.k;
    },
    leaveSlide() {
      this.hoverRoute = '';
    },
    handleResize() {
      // let hh = window.document.getElementById('jy-navbar-main').offsetHeight;
      // this.slideTop = hh;

      let ww = window.document.body.offsetWidth;
      if (ww < 1200) {
        this.showSlideTitle && this.toggleSlide()
      } else {
        !this.showSlideTitle && this.toggleSlide()
      }
    },
    addRoute() {
      if (!this.userinfo.permissions) return;
      let permissions = this.userinfo.permissions;
      // let router = this.$router;
      // console.log('addRoute...........', permissions, this.issys)
      let addChild = ((key, children) => {
        children.forEach(d => {
          this.$set(d.meta.r, 'invalid', false);
          if (this.issys && d.meta.issys == false) {
            d.meta.r.invalid = true;
          }
          if (d.meta.issys && !this.issys) {
            d.meta.r.invalid = true;
          }
          if (!d.meta.r.invalid) {
            if (!d.meta.r.k) {
              d.meta.r.invalid = false;
            } else {
              let role = key +'.'+ d.meta.r.k +'.'+ (d.meta.r.role || 'query');
              // console.log(role, permissions.indexOf(role))
              if (permissions.indexOf(role) > -1) {
                d.meta.r.invalid = false;
              } else {
                d.meta.r.invalid = true;
              }
            }
          }
          // console.log('d.meta.r.invalid', d.meta.r.v, d.meta.r.invalid)

          if (d.children) {
            addChild(key, d.children);
          }
        })
      });

      allRoute.forEach(obj => {
        Object.keys(obj).forEach(key => {
          if (this.routeData.indexOf(obj[key]) === -1) {
            if (permissions.indexOf(key) > -1) {
              if (obj[key].children)
                this.$router.addRoutes(obj[key].children);
              if (obj[key].path) {
                this.$router.addRoutes([obj[key]]);
              }
              this.routeData.push(obj[key]);
            }
          }

          if (obj[key].children)
            addChild(key, obj[key].children);
        });
      });
    },
    doChangePassword() {
      this.$refs.passwordDialog.show(true);
    },
    wheelNav(e) {
      let target = this.$refs.tagNav;
      let w = e.wheelDelta || e.detail;
      let left = 0;
      if (w > 0) {
        left = -120;
      } else {
        left = 120;
      }
      target.scrollLeft += left;
    },
    moveNav(e) {
      let target = this.$refs.tagNav;
      let x1 = e.pageX || e.touches[0].pageX;
      let L = target.scrollLeft || 0;
      const _move = (e) => {
        let left = (e.pageX || e.touches[0].pageX) - x1;
        L = L - left;
        if (L < 0) {
          L = 0;
        }
        target.scrollLeft = L;
      };
      const _stop = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        document.ontouchmove = null;
        document.ontouchend = null;
      };
      document.onmousemove = (e)=>{
        _move(e);
      };
      document.onmouseup = (e) => {
        _stop(e);
      };
      document.ontouchmove = (e)=>{
        _move(e);
      };
      document.ontouchend = (e) => {
        _stop(e);
      };
    },
    doLogin() {
      //this.$router.push('/');
      this.$refs.loginDialog.show(true);
    },
    loginOK() {
      // console.log('login...ok....')
      this.$refs.loginDialog.show(false);
      this.loginLoading && (this.loginLoading.close());
      // 激活JyPagebody
      //this.broadcast('JyPagebody', 'jy-activated', []);
      this.triggerActivated();
      this.broadcast('Home', 'jy-activated', []);
    }
  }
}
</script>

<style>
.bg-darkblue{background-color:#2D5F8B;}
#jy-navbar-main.show{z-index:99999;}
#jy-navbar-main{padding-left:.5rem;}
#jy-sidenav-col{/*position:absolute; left:0; top:0; bottom:0; z-index:8;*/ width:14rem; background-color:#FFF; /*border-left:1px #f1f1f1 solid; border-right:1px #f1f1f1 solid;*/ box-shadow:0 1px 8px rgba(0,0,0,.1);}
#jy-sidenav{position:relative; height:calc(100% - 32px);  overflow:hidden; /*background-color:#fff;*/ /*overflow:visible;*/}
#jy-sidenav-box{height:calc(100% + 17px);}
/*#jy-sidenav-box{height:calc(100% - 0px); }*/
/*.jy-sidenav-wrap{height:calc(100% + 0px);}*/
.jy-scrollbar.overflow-visible .jy-scrollbar__bar{display:none; z-index:-999;}
#jy-sidenav .jy-scrollbar__bar.is-vertical .jy-scrollbar__thumb{background-color:rgba(255,255,255,.6);}
#jy-sidenav-box .nav{display:block;}
#jy-sidenav-box .nav > li{border-top:0px transparent solid;}
#jy-sidenav-box .nav > li:first-child{border-top:none;}
/*#jy-sidenav-box .nav > li.open{border-bottom:1px #eee solid;}*/
#jy-sidenav-box .nav > li > a.router-link-active{/*background-color:#f1f1f1;*/}
#jy-sidenav-box .nav > li.router-link-active > a{/*background-color:#f1f1f1;*/}
#jy-sidenav-box .nav > li > a{position: relative; padding-top:.7rem; padding-bottom:.7rem; padding-left:.4rem; color:#555; border-right:3px #2D5F8B solid; /*border-bottom:1px #ddd solid;*/}
#jy-sidenav-box .nav > li > a:after{position: absolute; bottom:0; left:.5rem; right:1.5rem; content: " "; display: block; height:1px; background: linear-gradient(to right,#ffffff,#b6b6b6,#ffffff);}
#jy-sidenav-box .nav > li.open > a,
#jy-sidenav-box .nav > li > a:focus,
#jy-sidenav-box .nav > li .nav > li > a:focus{background-color:#D3E9FF;}
#jy-sidenav-box .nav > li .nav > li{margin-top:1px;}
#jy-sidenav-box .nav > li .nav > li > a{border-right:2px #2D5F8B solid;}
#jy-sidenav-box .nav > li .nav > li > a:after{display:none;}
#jy-sidenav-box .nav > li > a:hover,
#jy-sidenav-box .nav > li.active > a,
#jy-sidenav-box .nav > li > a.router-link-active,
#jy-sidenav-box .nav > li .nav > li > a:hover,
#jy-sidenav-box .nav > li .nav > li > a.router-link-active{background-color:#D3E9FF;}
#jy-sidenav-box .nav > li.active > a,
#jy-sidenav-box .nav > li > a.router-link-active,
#jy-sidenav-box .nav > li.isshow,
#jy-sidenav-box .nav > li.open{position:relative; /*padding-bottom:.25rem;*/ /*border-bottom:1px #ddd solid;*/}
#jy-sidenav-box .nav > li.isshow:after{position: absolute; bottom:0px; left:.5rem; right:1.5rem; content: " "; display: block; height:1px; background: linear-gradient(to right,#ffffff,#b6b6b6,#ffffff);}
#jy-sidenav-box .nav > li.open:after{position: absolute; bottom:-2px; left:.5rem; right:1.5rem; content: " "; display: block; height:1px; background: linear-gradient(to right,#ffffff,#b6b6b6,#ffffff);}
#jy-sidenav-box .nav > li.isshow > a{border-bottom-color:transparent;}
#jy-sidenav-box .nav > li.open > a{color:#1786EF; border-bottom-color:transparent;}
#jy-sidenav-box .nav > li.open > a,
#jy-sidenav-box .nav > li > a:hover{color:#1786EF; background-color:#fff;}
/*#jy-sidenav-box .nav > li .nav{display:none;}*/
/*#jy-sidenav-box .nav > li.active > .nav{display:block;}*/
#jy-sidenav-box .nav > li.open .nav{/*margin-top:.25rem; margin-bottom:.25rem;*/}
#jy-sidenav-box .nav > li .nav > li{margin-bottom:1px;}
#jy-sidenav-box .nav > li .nav > li > a{padding-left:2rem; padding-top:.5rem; padding-bottom:.5rem; color:#555; border-bottom:none;}
#jy-sidenav-box .nav > li.isshow > a:after,
#jy-sidenav-box .nav > li.open > a:after,
#jy-sidenav-box .nav > li .nav > li > a:after{background:#fff;}
#jy-sidenav-box .nav > li.sub-menu{position:relative;}
#jy-sidenav-box .nav > li.sub-menu > a{background-color:#27272B; border-right-color:#27272B;}
#jy-sidenav-box .nav > li.sub-menu > a:hover{border-right:none;}
#jy-sidenav-box .nav > li.sub-menu > a > span{position:absolute; left:2.35rem; top:0px; display:block !important; padding-left:0rem; padding-top:.5rem; padding-bottom:.75rem; width:10.05rem; height:2.4rem; background-color:#27272B; border-top:1px solid #414247;}
#jy-sidenav-box .nav > li.sub-menu > a:hover > span{background-color:#27272B;}
#jy-sidenav-box .nav > li.sub-menu > a b{display:none;}
#jy-sidenav-box .nav > li.active > a{border-right-color:#ff6600 !important;}
#jy-sidenav-box .nav > li.sub-menu.active > a{border-right-color:#27272B !important;}
#jy-sidenav-box .nav > li.sub-menu.active > a > span{border-right:3px solid #ff6600 !important;}
#jy-sidenav-box .nav > li.sub-menu > ul{position:absolute; left:2.4rem; top:2.35rem; width:10rem; background-color:#35363a;}
#jy-sidenav-box .nav > li.sub-menu .nav > li{display:block !important; min-height:2.5rem !important; opacity:1 !important; transition:all .1s ease-in;}
#jy-sidenav-box .nav > li.sub-menu .nav > li > a{padding-left:.5rem; border-right:none;}
#jy-sidenav-box .nav > li .nav > li .nav > li > a{padding-left:50px;}
#jy-sidenav-box .nav > li > a.right-arrow{position:relative;}
#jy-sidenav-box .nav > li > a.right-arrow b{position:absolute; right:7px;}
#jy-sidenav-box .nav > li > a.right-arrow b > i{-webkit-transition:all .3s ease-in; transition:all .3s ease-in;}
#jy-sidenav-box .nav > li > a.right-arrow:hover b > i,
#jy-sidenav-box .nav > li.isshow > a.right-arrow b > i,
#jy-sidenav-box .nav > li.open > a.right-arrow b > i{-webkit-transform:rotate(90deg); -ms-transform:rotate(90deg); transform:rotate(90deg);}
#jy-sidenav-box .nav > li.isshow > a.right-arrow:hover b > i,
#jy-sidenav-box .nav > li.open > a.right-arrow:hover b > i{-webkit-transform:rotate(-90deg); -ms-transform:rotate(-90deg); transform:rotate(-90deg);}
#jy-sidenav-btn{position:absolute; top:40%; left:1px; z-index:1; display:none; width:40px; height:40px; text-align:center; font-size:20px; line-height:40px; color:#fff; background-color:#999; background-color:rgba(0,0,0,.5); border-radius:20px; cursor:pointer;}
#jy-sidenav-btn:hover,
#jy-sidenav-btn > i{-webkit-transition:all .3s ease-in; transition:all .3s ease-in;}
#jy-sidenav-btn:hover > i{-webkit-transform:rotate(720deg); -ms-transform:rotate(720deg); transform:rotate(720deg);}

#jy-sidenav-box .nav > li > a:hover,
#jy-sidenav-box .nav > li > a.router-link-active,
#jy-sidenav-box .nav > li .nav > li > a:hover,
#jy-sidenav-box .nav > li .nav > li > a.router-link-active{
  border-right-color:#ff6600 !important;
}

.sidenav-collapse{/*position:absolute; z-index:2; bottom:0;*/ padding:.3rem; width:100%; text-align:center; color:#fff; border-top:1px #666 solid; cursor:pointer; background-color:#2D5F8B;}
.sidenav-collapse:hover{background-color:#27272B;}

#jy-breadcrumb{position:relative; z-index:5; background-color:#fff; border-bottom:1px #ccc solid;}
.main-breadcrumb{position:relative; z-index:5; padding:.4rem 1rem; background-color:#fff; border-radius:0;}
.main-breadcrumb.scrolled{width:calc(100% - 17px);}

.nav-main{position:fixed; top:56px; left:14rem; right:0; z-index:-5; padding:.5rem .5rem; background-color:rgba(0,0,0,.05);}
.nav-main a{margin-right:2px; cursor:pointer; font-size:16px; background-color:#fefefe; border:1px #ddd solid;}
.nav-main > li{position:relative;}
.nav-main > li > a.router-link-active,
.nav-main > li > a.router-link-active:focus,
.nav-main > li > a.router-link-active:hover {
    color: #fff;
    background-color: #337ab7;
    border-color:#337ab7;
}
.nav-main > li .nav-close{position:absolute; top:2px; right:3px; display:none; width:1rem; height:1rem; line-height:1rem; text-align:center; color:#fff; background-color:#000; border-radius:.5rem; cursor:pointer;}
.nav-main > li .nav-close:hover{background-color:red;}
.nav-main > li:hover .nav-close{display:block;}
.nav-main > li > a{padding:.2rem 1.2rem .2rem 1.2rem;}

.navbar{padding-top:.3rem; padding-bottom:.3rem;}
.navbar.show{z-index:2;}
.fa-chevron-circle-down.show{transform:rotate(180deg);}
.navbar-text > span{display:inline-block; vertical-align:middle;}
.navbar-text > span.space{margin-top:-2px; color:#666;}

/**/
/*textarea.form-control{padding-top:.5rem; padding-bottom:.5rem;}*/
/**/
.jy-pageBody{/*position:absolute; left:14rem; top:5rem; bottom:0rem; right:0;*/ display:flex; flex-direction:column; flex-grow:1; padding:1.2rem; width:100%; height:100%; background-color:#eaedf1;}
.jy-pageFooter{/*position:fixed; left:14rem; bottom:0; right:0; z-index:5;*/ padding:.4rem .5rem; text-align:center; background-color:rgba(255,255,255,.95); border-top:1px #fff solid; box-shadow:0px -5px 8px 1px rgba(0,0,0,.15);}
.jy-quickLink{position:absolute; z-index:9999999; left:50%; transform:rotate(-50%);}
.el-tag.el-tag-route{height:1.8rem; font-size:1rem; line-height:1.8rem; cursor:pointer;}
.el-tag.el-tag-route.el-tag--info{color:#a1a1a1; border-color:#999; background-color:#eee;}
.el-tag.el-tag-route.el-tag--info:hover{color:#555; background:#ddd;}

.submenu-tooltip{left:35px !important; margin-left:5px !important;}
.submenu-tooltip .card .card-header{font-weight:bold;}
.submenu-tooltip .card .card-header,
.submenu-tooltip .card .list-group-item{padding:.4rem .75rem;}
.submenu-tooltip .card .list-group-item.router-link-active{color:#ff6600;}

@media (max-width: 991.98px) {
  .navbar-expand-lg .navbar-collapse{border-top:1px #777 dotted;}
  .navbar-expand-lg .navbar-nav{display:block; font-size:0;}
  .navbar-expand-lg .navbar-nav > li{display:inline-block; width:16.5%;}
  .navbar-expand-lg .navbar-nav > li > a{font-size:1rem;}
  .navbar-expand-lg .navbar-nav > li > a:before{content:"·"; display:inline-block; margin-right:.5rem;}
  .navbar-expand-lg .navbar-text{width:100%; text-align:right; border-top:1px #777 dotted;}
}
@media (max-width: 767.98px) {
  .navbar-expand-lg .navbar-nav > li{width:24.5%;}
}
@media (max-width: 575.98px) {
  .jy-pageBody{padding-left:.8rem; padding-right:.8rem;}
  .navbar-expand-lg .navbar-nav > li{width:33.3%;}
  .navbar-brand{font-size:1rem; white-space:nowrap; overflow:hidden;}
  .navbar-brand img{height:20px !important;}
  .navbar-toggler{position:absolute; right:1px; top:.45rem;}
}
@media (max-width: 420px) {
  .el-message-box{width:100% !important;}
}

.bg-light1{background-color:#cce5ff;}
.bg-light2{background-color:#d4edda;}
.bg-light3{background-color:#f8d7da;}
.bg-light4{background-color:#d1ecf1;}
.bg-light5{background-color:#fff3cd;}
.bg-light6{background-color:#e2e3e5;}

.bg-light1 >>> .el-table,
.bg-light2 >>> .el-table,
.bg-light3 >>> .el-table,
.bg-light4 >>> .el-table,
.bg-light5 >>> .el-table,
.bg-light6 >>> .el-table {
  background-color:transparent !important;
}

/**/
label{margin-bottom:0;}
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; position: relative; overflow: hidden;}
.avatar-uploader .el-upload:hover {border-color: #409EFF;}
.avatar-uploader-icon {font-size: 28px; color: #8c939d; width: 58px; max-height: 58px; line-height: 58px; text-align: center;}
.avatar {width: 58px; max-height: 58px; display: block;}
.el-dialog__headerbtn{top:1px !important; right:1px !important;}
.el-dialog__headerbtn .el-dialog__close{font-size:2.6rem;}
button, button:focus{outline:none !important;}
.el-dialog__footer{padding:1rem !important; background-color:#eee;}
.el-form.el-form--label-top .el-form-item__label{padding-bottom:3px; padding-right:0; line-height:1.5;}
.el-form-item .el-form-item__label{color:#999;}
.el-form-item .jy-badge{vertical-align:top;}
.el-form-item__content{color:#222;}
.el-form-item.hover:hover{background-color:#f8f8f8;}
.el-form-item.label-top .el-form-item__label{float:none; display:block; padding-right:0; width:100% !important; text-align:left;}
.el-form-item.label-top .el-form-item__content{margin-left:0 !important;}
.el-form-item.label-center .el-form-item__label{float:none; display:block; padding-right:0; width:100% !important; text-align:center;}
.el-form-item.label-center .el-form-item__content{margin-left:0 !important;}
.el-form-item .el-select{width:100%;}
.view-form .el-form-item--mini.el-form-item, .view-form .el-form-item--small.el-form-item,
.view-row .el-form-item--mini.el-form-item, .view-row .el-form-item--small.el-form-item{margin-bottom:4px;}
.view-form .el-form-item--small .el-form-item__content, .view-form .el-form-item--small .el-form-item__label,
.view-row .el-form-item--small .el-form-item__content, .view-row .el-form-item--small .el-form-item__label{padding-top:.16rem; padding-bottom:.16rem; line-height:1.65;}
.el-form .w-e-toolbar{line-height:1.2}
.el-form .w-e-toolbar .w-e-menu{padding:5px 8px;}
.el-input--small .el-input__inner{padding:0 8px;}
.el-input--small.el-date-editor--date .el-input__inner{padding-left:30px;}
.el-input--small .el-textarea__inner{padding-left:8px; padding-right:8px;}
.el-input--small .el-input-group__append, .el-input--small .el-input-group__prepend{padding-left:8px; padding-right:8px;}
.el-cascader--small .el-cascader__search-input,
.el-select--small .el-select__input{margin-left:8px;}
.el-date-editor.el-input, .el-date-editor.el-input__inner{width:100% !important;}
.el-date-editor.el-range-editor--small .el-range-separator{width:8%;}
.el-autocomplete,
.el-autocomplete .el-input,
.el-autocomplete .el-input__inner{width:100%;}
.el-checkbox, .el-radio, .el-radio-button{margin-bottom:0;}
.el-radio-button.icon .el-radio-button__inner{padding:5px 10px; font-size:16px;}
.jy-pageBody .el-table th {padding: 6px 0;}
.jy-pageBody .el-table td {padding: 10px 0;}
.jy-pageBody .el-table th > .cell,
.jy-pageBody .el-table .el-table__column-filter-trigger{line-height:1.15;}
.jy-pageBody .el-table .caret-wrapper{height:16px;}
.jy-pageBody .el-table .sort-caret.ascending{top:-5px;}
.jy-pageBody .el-table .sort-caret.descending{bottom:-2px;}
.el-table .edit_table_row .cell,
.el-table .edit_table_row td{padding-top:3px; padding-bottom:3px;}
.el-table .edit_table_row .el-input__inner{padding:0 5px;}
.el-table .edit_table_row .el-input--small.el-date-editor--date .el-input__inner{padding-left:30px;}
.el-table .edit_table_row .el-form-item{margin-bottom:0;} 
.el-table .edit_table_row .el-form-item.is-error{margin-bottom:16px;}
.el-table .edit_table_row .cell{display:flex; align-items:center;}
.el-table .edit_table_row .cell .el-row{flex:1;}
.el-table .edit_table_row .cell .el-table__expand-icon{flex-shrink:0;}
.image-slot {display:flex; justify-content:center; align-items:center; width:100%; height:100%; background:#f5f7fa; color:#909399; font-size:1.2rem;}
.el-row .col-jy {
  flex-grow: 1;
  width: 100%;
}
.el-message,
.el-message-box__wrapper{z-index:5000 !important;}
.el-picker-panel,
.el-popover{z-index:4999 !important;}
header.el-drawer__header > span{outline:none;}
.el-scrollbar__wrap.wrap-x-none{overflow-x:hidden;}
.el-drawer__body{overflow-y:hidden;}
.el-switch__label--right{margin-left:.25rem !important;}
.text-info .el-divider__text {color:#17a2b8!important;}
@media (max-width: 575.98px) {
  .el-form-item{padding:0 .5rem;}
  .el-form-item .el-form-item__label{float:none; width:100% !important; text-align:left; line-height:1 !important;}
  .el-form-item .el-form-item__content{margin-left:0 !important; line-height:1.45 !important;}
  .card-header, .card-body, .card-footer{padding:.5rem;}
  .el-pagination{white-space:normal !important;}
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{margin:0px !important;}
  .col-gutters-10{margin-left:-5px; margin-right:-5px;}
  .col-gutters-10 > .col, .col-gutters-10 > [class*="col-"]{padding-left:5px; padding-right:5px;}
}
@media (min-width: 576px) {
  .el-row .col-jy {
    flex-grow: 1;
    width: 100%;
  }
}
@media (min-width: 768px) {
  .el-row .col-jy {
    flex: 0 0 50%;
    width: 50%;
  }
  .el-row .col-jy.fill-2, .el-row .col-jy.fill-3, .el-row .col-jy.fill-4 {
    flex: 0 0 100%;
    width: 100%;
  }
}
@media (min-width: 992px) {
  .el-row .col-jy {
    flex: 0 0 33.33333%;
    width: 33.33333%;
  }
  .el-row .col-jy.fill-2 {
    flex: 0 0 66.66666%;
    width: 66.66666%;
  }
  .el-row .col-jy.fill-3, .el-row .col-jy.fill-4 {
    flex: 0 0 100%;
    width: 100%;
  }
}
@media (min-width: 1200px) {
  .el-row .col-jy {
    flex: 0 0 25%;
    width: 25%;
  }
  .el-row .col-jy.fill-2 {
    flex: 0 0 50%;
    width: 50%;
  }
  .el-row .col-jy.fill-3 {
    flex: 0 0 75%;
    width: 75%;
  }
  .el-row .col-jy.fill-4 {
    flex: 0 0 100%;
    width: 100%;
  }
}
</style>